import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResq = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "resq" }), /* @__PURE__ */ _jsx("path", {
		style: {
			fill: "currentColor",
			stroke: "none"
		},
		d: "M20.6507 19.0576C22.3177 17.0438 23.3194 14.4605 23.3194 11.6437C23.3194 5.21305 18.0992 0 11.6597 0C9.37634 0 7.24628 0.655447 5.4479 1.78821L8.58195 5.52103C9.50752 5.05611 10.553 4.79434 11.6597 4.79434C15.4477 4.79434 18.5184 7.86084 18.5184 11.6436C18.5184 12.9767 18.137 14.2209 17.4772 15.2732L13.516 10.5497L10.2329 13.3091L14.1798 18.0157C13.3997 18.3236 12.5495 18.4928 11.6597 18.4928C7.87182 18.4928 4.8011 15.4263 4.8011 11.6436C4.8011 10.1282 5.29387 8.72785 6.12811 7.59348L2.99085 3.85682C1.13154 5.91971 0 8.64973 0 11.6437C0 18.0743 5.22022 23.2873 11.6597 23.2873C13.7291 23.2873 15.6726 22.749 17.3574 21.8048L19.1982 24L22.4814 21.2406L20.6507 19.0576Z"
	})]
});
export default SvgResq;
